import 'tippy.js/dist/tippy.css';

import * as S from './styles';

import { MapPinned, Trophy } from 'lucide-react';
import React, { useCallback } from 'react';

import { DivProps } from '../../../../../typings';
import Tippy from '@tippyjs/react';
import { TourneyEncoded } from 'modules/tournaments/domain/interfaces/tourney-encoded';
import { TourneyStatus } from 'modules/tournaments/domain/enums/tourney-status';
import UDText from 'ud-ui/components/text';
import classNames from 'classnames';
import { Championship } from 'modules/tournaments/domain/interfaces/responce-dto';

type Props = {
  // tourney: TourneyEncoded;
  tourney: Championship;
  containerProps?: Omit<DivProps, 'children' | 'onClick'>;
  onClickCard: (id: TourneyEncoded['id']) => any;
};

const statusIndicatorMessage = {
  [TourneyStatus.OPEN]: 'Прием заявок открыт',
  [TourneyStatus.CLOSE]: 'Прием заявок закрыт',
};

const TourneyComponentsTourneyCard = (props: Props) => {
  const start = props.tourney.startDate ? new Date(props.tourney.startDate).toLocaleDateString('ru') : null;
  const end = props.tourney.endDate ? new Date(props.tourney.endDate).toLocaleDateString('ru') : null;

  const onClickCard = useCallback(() => {
    props.onClickCard(props.tourney.id);
  }, [props]);

  return (
    <S.CardContainer
      {...props.containerProps}
      className={classNames('flex flex-col py-4 pl-3 pr-4', props.containerProps?.className)}
      onClick={onClickCard}
    >
      <div className="flex items-center mb-5 flex flex-row">
        <Trophy size={16} className="mr-1" />
        <UDText type="caption-2" className="text-surfaceRomanSilver30">
          Турнир
        </UDText>
        <MapPinned size={16} className="text-surfaceRomanSilver30 ml-auto mr-1" />
        <UDText type="caption-2" className="text-surfaceRomanSilver30">
          {props.tourney.address?.city}
        </UDText>
      </div>
      <S.StyledTournamentName type="subhead" className="bold">
        {props.tourney.name}
      </S.StyledTournamentName>
      <div className="flex items-center justify-between mt-auto flex flex-row">
        <UDText type="subhead" className="date text-surfaceRichBlack60">
          {start} — {end || <span className="text-surfaceRomanSilver30">открытая дата</span>}
        </UDText>
        <Tippy content={statusIndicatorMessage[props.tourney?.status ?? TourneyStatus.CLOSE]} placement="right" interactive={false}>
          <S.StatusIndicator data-status={props.tourney?.status} />
        </Tippy>
      </div>
    </S.CardContainer>
  );
};

export default TourneyComponentsTourneyCard;
